import { render, staticRenderFns } from "./PipButton.vue?vue&type=template&id=40019c4a&"
import script from "./PipButton.vue?vue&type=script&lang=js&"
export * from "./PipButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports